(function () {
  const form = document.getElementById("bss-b2b-registration-form");
  if (!form) return;

  // ===== BLOCK 1 (ABOVE FORM) =====
  const topBlock = document.createElement("div");
  topBlock.innerHTML = `
    <div class="b2b-top-block" style="margin-bottom: 24px;">
      <h2 style="font-size: 28px; font-weight: 700; margin-bottom: 10px;">
        Become a <span style="color:#8BC34A;">Innovative CBD</span> Wholesale Partner
      </h2>
      <p style="margin-bottom: 16px;">
        Join a trusted, established CBD brand with proven retail sell-through,
        premium full-spectrum products and strong margins.
      </p>
      <ul style="padding-left: 18px; line-height: 1.8;">
        <li>✔ Established brand with loyal customer base</li>
        <li>✔ Full spectrum CO2 extraction (no solvents)</li>
        <li>✔ High repeat purchase products (sleep, pain, stress)</li>
        <li>✔ Retail-friendly margins</li>
        <li>✔ Lab-tested & compliant products</li>
      </ul>
    </div>
  `;

  // ===== BLOCK 2 (BELOW FORM) =====
  const bottomBlock = document.createElement("div");
  bottomBlock.innerHTML = `
    <div class="b2b-bottom-block" style="margin-top: 24px; text-align:center;">
      <p>Applications are reviewed within 24-48 hours</p>
      <p>You'll receive login access + wholesale pricing via email</p>
      <p>Need faster approval? Contact us below</p>
      <p><strong>Phone Number:</strong> 800-618-9662</p>
      <p><strong>Email:</strong> wholesale@InnovativeCBD.com</p>
      <p style="margin-top: 12px; font-style: italic;">
        Most approved accounts place their first order within 24 hours of approval
      </p>
    </div>
  `;

  // ===== INSERT =====
  form.parentNode.insertBefore(topBlock, form);
  form.parentNode.insertBefore(bottomBlock, form.nextSibling);
})();


(function () {
  const QV_SELECTOR = '.quick-product';
  const FIRED_ATTR = 'data-bss-qv-fired';

  function getQuickView() {
    return document.querySelector(QV_SELECTOR);
  }

  function fireQuickviewLoadedOnce() {
    const qv = getQuickView();
    if (!qv || qv.hasAttribute(FIRED_ATTR)) return false;

    qv.setAttribute('bss-b2b-quickview-product-form', '');
    qv.setAttribute(FIRED_ATTR, 'true');

    qv.dispatchEvent(
      new Event('bss_b2b:QuickviewLoaded', { bubbles: true })
    );

    setTimeout(function () {
      BSS_B2B?.observer?.productSubject?.init?.();
    }, 300);

    return true;
  }

  const observer = new MutationObserver(function () {
    fireQuickviewLoadedOnce();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  document.addEventListener('click', function (e) {
    const button = e.target.closest('.product__chip.dynamic-variant-button');
    if (!button) return;

    setTimeout(function () {
      const qv = getQuickView();
      if (!qv) return;

      const variantInput = qv.querySelector('input[name="id"], select[name="id"]');

      if (variantInput) {
        variantInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }, 700);
  });
})();


document.addEventListener('DOMContentLoaded', (event) => {
  setTimeout(() => {
    BSS_B2B.observer.productSubject.notifyObserver('ProductMutate', 'ProductPriceMutate');
  }, 2000);
  const buttons = document.querySelectorAll('.product__chip.dynamic-variant-button');

  buttons.forEach(button => {
    button.addEventListener("click", e => {
      e.preventDefault();
      setTimeout(() => {
        const productForm = document.querySelector("[bss-b2b-main-product-form]");
        BSS_B2B.observer.productSubject.notifyObserver('VariantChange', 'VariantSelectChange', { productForm });
      }, 1000);
    });
  });
});

window.bssB2BHooks = window.bssB2BHooks || {
  actions: {},
  filters: {},
};
window.BSS_B2B = window.BSS_B2B || {};
window.BSS_B2B.addAction = (tag, callback) => {
  window.bssB2BHooks.actions[tag] = callback;
};
window.BSS_B2B.addFilter = (tag, value) => {
  window.bssB2BHooks.filters[tag] = value;
};
const funcHandle = ({ a, b, c}) => {
  // handle something
};
window.BSS_B2B.addAction("handleSomething", funcHandle ); 

function applySubscriptionPrice() {
    const priceSource = document.querySelector(
        ".product__price[bss-b2b-variant-price]"
    );
    if (!priceSource) return;

    /* ================== PARSE GIÁ GỐC ================== */
    const spans = priceSource.querySelectorAll("span");

    if (spans.length < 2) return;

    const compareText = spans[0].textContent.trim(); // $49.99
    const saleText = spans[1].textContent.trim();    // $25.00

    const match = compareText.match(/([\£\€\$])([\d.]+)/);
    if (!match) return;

    const currency = match[1];
    const basePrice = parseFloat(match[2]);

    /* ================== ONE TIME ================== */
    const oneTime = document.querySelector(".appstle_one_time_price_wrapper");
    if (oneTime) {
        // 👉 giữ nguyên style gốc
        oneTime.innerHTML = priceSource.innerHTML;
    }

    /* ================== SUBSCRIBE ================== */

    // 👉 lấy % discount
    const label = document.querySelector(
        '.payAsYouGoPlansDropdownWrapper label[for^="appstle_selling_plan_label_"]'
    );
    if (!label) return;

    const percentMatch = label.getAttribute("for").match(/(\d+)$/);
    if (!percentMatch) return;

    const discount = parseInt(percentMatch[1], 10);

    const discountedPrice = (basePrice * (1 - 15 / 100)).toFixed(2);

    const subPrice = document.querySelector(".appstle_subscription_amount.transcy-money");

    if (subPrice) {
        subPrice.innerHTML = ""; // tránh duplicate

        subPrice.innerHTML = `
            <div>
                <div style="font-weight: 600;">
                    ${currency}${discountedPrice}
                </div>
                <div style="text-decoration: line-through; color: #303030;">
                    ${compareText}
                </div>
                <div style="color: #E51C00;">
                    ${saleText}
                </div>
            </div>
        `;
    }

    /* ================== COMPARE (optional) ================== */
    const compare = document.querySelector(".appstle_subscription_compare_amount.transcy-money");
    compare.style.display = "none";
}

document.addEventListener("DOMContentLoaded", () => {
    // khi đổi purchase option
    document.addEventListener("change", (e) => {
        if (e.target.closest(".appstle_subscription_wrapper")) {
            setTimeout(() => {
                applySubscriptionPrice();
            }, 200);
        }
    });
});

let counter = 0;
let selector = ".appstle_subscription_wrapper"
const interval = setInterval(() => {
    let element = document.querySelector(selector);
    if (element) {
        console.log("Phần tử đã xuất hiện");
        clearInterval(interval);
        setTimeout(()=> {
          applySubscriptionPrice();
        }, 1000)
    } else {
        counter += 100;
        if (counter >= 10000) {
            clearInterval(interval);
        }
    }
}, 100);

if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
    setTimeout(() => {
      const observer = new MutationObserver((MutationList) => {
        for (let item of MutationList) {
          if (item.target.classList?.contains('appstle_subscription_wrapper')) {
            setTimeout(()=> {
              applySubscriptionPrice();
            }, 2000)
          }
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }, 300);
  }